import { fetchSnippetTypes } from "../../serviceCalls";
import { observable } from "mobx";

const documentLabels = observable({
  // defaults
  showsDocumentTypePicker: false,
  snippetDocumentTypes: {
    0: "PRN",
    1: "Admission Baseline",
    2: "Shift Assessment",
    3: "EVENT",
  },
});

documentLabels.promise = new Promise((resolve) => {
  documentLabels.fetch = () =>
    fetchSnippetTypes()
      .then((res) => {
        if (!res.snippetDocumentTypes) delete res.snippetDocumentTypes;
        Object.assign(documentLabels, res);
        resolve(documentLabels);
      })
      .catch(() => resolve(documentLabels));
});

export default documentLabels;
